const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

export function formatTrialDate(dateString, locale = 'en') {
	if (typeof dateString !== 'string') return ''

	const match = DATE_ONLY_PATTERN.exec(dateString)
	if (!match) return ''

	const [, year, month, day] = match
	const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)))

	if (
		date.getUTCFullYear() !== Number(year) ||
		date.getUTCMonth() !== Number(month) - 1 ||
		date.getUTCDate() !== Number(day)
	) {
		return ''
	}

	return date.toLocaleDateString(locale, {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		timeZone: 'UTC'
	})
}
